
import { CookieComponent } from "@/assets/ts/components/_CookieComponent";
import { defineComponent } from "vue";

export default defineComponent({
  name: "account-overview",
  computed: {
    user() {
      return JSON.parse(CookieComponent.get("userData") as string);
    },
  },
});
